import React from 'react';
import { Route } from 'react-router-dom';

export const ProviderRouter = ({ provider, component, path }) => {
  const Provider = provider;
  const Component = component;
  // 統一將 Provider 包在通路的 router 內，避免每個通路內的檔案都要包上 provider
  return (
    <Route path={path}>
      <Provider>
        <Component />
      </Provider>
    </Route>
  );
};
